export default __webpack_public_path__ + "static/media/butterfly.2cce787a.png";